import { Map,Record } from "immutable";

import filterMatchOptions from "../../../../constants/filterMatchOptions";
import createFromJS from "../../../createFromJS";
import { ListFilterPartRecord } from "./ListFilterPartRecord";
import { NarrativeFilterPartRecord } from "./NarrativeFilterPartRecord";
import { RangeFilterPartRecord } from "./RangeFilterPartRecord";

export const FilterRecord = Record({
  matchCriteria: filterMatchOptions.ALL,
  label: ListFilterPartRecord(),
  summary: ListFilterPartRecord(),
  tags: ListFilterPartRecord(),
  type: ListFilterPartRecord(),
  color: ListFilterPartRecord(),
  super: ListFilterPartRecord(),
  date: RangeFilterPartRecord(),
  duration: RangeFilterPartRecord(),
  narrative: NarrativeFilterPartRecord(),
  relationshipsByType: Map(),
  relationshipsByReference: Map(),
  textProperties: Map(),
  numericProperties: Map(),
  boolProperties: Map()
});

const data = {
  objects: {
    label: "ListFilterPartRecord",
    summary: "ListFilterPartRecord",
    tags: "ListFilterPartRecord",
    type: "ListFilterPartRecord",
    color: "ListFilterPartRecord",
    super: "ListFilterPartRecord",
    date: "RangeFilterPartRecord",
    duration: "RangeFilterPartRecord",
    narrative: "NarrativeFilterPartRecord"
  },
  collections: {
    relationshipsByType: "ListFilterPartRecord",
    relationshipsByReference: "ListFilterPartRecord",
    textProperties: "ListFilterPartRecord",
    numericProperties: "RangeFilterPartRecord",
    boolProperties: "BoolFilterPartRecord"
  }
};
createFromJS.registerCallback("FilterRecord", createFromJS.createNestedCallback(FilterRecord, data));
